<div class="area-action-buttons">
  <div class="area-action-button">
    <div class="dropdown">
      <a
        class="dropdown-toggle"
        role="button"
        id="dropdownMenuLinkCity"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ this.selectedCity === null ? "Select a city" : this.selectedCity }}
      </a>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkCity">
        <a
          class="dropdown-item"
          *ngFor="let city of cities"
          (click)="citySelected(city)"
        >
          {{ city }}
        </a>
      </div>
    </div>
  </div>

  <div class="area-action-button" *ngIf="selectedCity">
    <div class="dropdown">
      <a
        class="dropdown-toggle"
        role="button"
        id="dropdownMenuLinkArea"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{
          this.selectedFiberHood === null
            ? "Select a FH"
            : this.selectedFiberHood.fiberHood
        }}
      </a>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkArea">
        <a
          class="dropdown-item"
          *ngFor="let fiberHood of fiberHoodList"
          value="{{ Id }}"
          (click)="fiberHoodSelected(fiberHood)"
        >
          {{ fiberHood.fiberHood }}
        </a>
      </div>
    </div>
  </div>

  <div class="area-action-button" *ngIf="selectedFiberHood">
    <div class="dropdown">
      <a
        class="dropdown-toggle"
        role="button"
        id="dropdownMenuLinkFH"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{
          this.selectedBlock === null
            ? "Select a block"
            : this.selectedBlock.block
        }}
      </a>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkFH">
        <a
          class="dropdown-item"
          *ngFor="let block of blockList"
          (click)="blockSelected(block)"
        >
          {{ block.block }}
        </a>
      </div>
    </div>
  </div>
</div>
